import { IDiscount, IInvoiceLine, IProduct, IProductVariant, IProfile, OfferType } from '@jumpstart/core';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { collection, deleteDoc, doc, QueryDocumentSnapshot, setDoc, updateDoc } from 'firebase/firestore';
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useCollection } from 'react-firebase-hooks/firestore';
import { IMAGE_PLACEHOLDER } from '../../../core/utils';
import { ActionsService } from '../action-service';

// @TODO use actions route
// import { IMAGE_PLACEHOLDER } from '../../../../core';
// import { ActionsService } from '../../../actions/actions-service';
// import AddressView from '../../../actions/AddressView';
// import { MissingOrder } from '../../../actions/components/MissingActions';
// import OrderItemView from '../../../actions/OrderItemView';
// import PaymentReview from '../../../actions/PaymentReview';
import InvoiceDiscountsView from './InvoiceDiscountsView';
import ProductSelectionView, { IProductSelection } from './ProductSelectionView';


export interface IOrderCreationView {
  uid: string;
  profile: IProfile;
  invoice: QueryDocumentSnapshot;
}


export default function InvoiceCreationView(props: IOrderCreationView) {
  const { invoice, uid, profile } = props;
  const [discounts, setDiscounts] = useState<IDiscount[]>([]);
  const [products, setProducts] = useState<IProductSelection[]>([]);
  const [lines] = useCollection(
    collection(invoice.ref, 'lines')
  );
  const [syncing, setSyncing] = useState(false);
  const [copiedText, setCopiedText] = useState('');

  const lineFromProductSelection = (product: IProduct, seller: string, variant: IProductVariant): IInvoiceLine => {
    return {
      id: product.id,
      offerType: OfferType.PRODUCT,
      img: product.media ? product.media : IMAGE_PLACEHOLDER,
      itemName: product.name,
      actionName: '',
      itemId: product.name,
      variantId: variant.id,
      retailerId: seller,
      quantity: 1,
      prompts: null,
      unitPrice: {
        value: variant.pricing.listPrice ? variant.pricing.listPrice * 100 : 0,
        currency: variant.pricing.currency
      },
      amount: {
        value: variant.pricing.listPrice ? variant.pricing.listPrice * 100 : 0,
        currency: variant.pricing.currency
      },
      purchasing: null,
      packaging: {
        weight: {
          unit: variant.size.measurement as any,
          value: variant.size.weight
        },
        dimensions: {
          unit: variant.size.length.measurement as any,
          height: variant.size.height.value as any,
          width: variant.size.width.value as any,
          length: variant.size.length.value as any
        }
      }
    };
  };

  const syncLines = async (_products: IProductSelection[], _discounts: IDiscount[]) => {
    if (syncing) {
      console.error('Altering in sync');
      return;
    }

    await updateDoc(invoice.ref, { discounts: _discounts });
    if (!lines) {
      return;
    }
    // Remove lines that are not part of the product
    for (const line of lines.docs) {
      const index: number = _products.findIndex(p => p.product.id === line.id);
      if (index === -1) {
        await deleteDoc(line.ref);
      }
    }
    for (const { product, seller, variant } of _products) {
      await setDoc(doc(invoice.ref, 'lines', product.id), lineFromProductSelection(product, seller, variant));
    }
    const { estimate, total } = await ActionsService.recalculate({
      production: process.env.NODE_ENV !== 'development',
      invoice: invoice.id,
      uid: uid
    });
    console.log('New Total', estimate, total);
    setSyncing(false);
  };

  const handleOnAddProducts = (newProducts: IProductSelection[]) => {
    setProducts(newProducts);
    syncLines(newProducts, discounts)
      .catch((err: Error) => {
        console.error(err.message);
      });
  };

  const handleOnAddDiscounts = (newDiscounts: IDiscount[]) => {
    setDiscounts(newDiscounts);
    syncLines(products, newDiscounts)
      .catch((err: Error) => {
        console.error(err.message);
      });
  };

  // const handleEditLine = async (line: IInvoiceLine) => {
  //   console.log(line.id);
  //   await invoice.ref.collection('lines').doc(line.id).update(line)
  //     .catch((err: Error) => {
  //       console.error('Failed to update line', err);
  //     });
  //   const { estimate, total } = await ActionsService.recalculate({
  //     production: process.env.NODE_ENV !== 'development',
  //     invoice: invoice.id,
  //     uid: uid
  //   });
  //   console.log('New Total', estimate, total);
  // };

  return (
    <Grid container direction="column" spacing={8}>
      <Grid item container>
        <ProductSelectionView onAdd={handleOnAddProducts}/>
      </Grid>
      <Grid item container>
        <InvoiceDiscountsView onAdd={handleOnAddDiscounts}/>
      </Grid>

      <Grid item container>
        <Typography variant="h4">Invoice</Typography>

        {/*{*/}
        {/*  !!lines ?*/}
        {/*    <OrderItemView*/}
        {/*      lines={lines.docs.map((d: firebase.firestore.QueryDocumentSnapshot) => d.data() as IInvoiceLine)}*/}
        {/*      edit={true}*/}
        {/*      onEdited={handleEditLine}*/}
        {/*    />*/}
        {/*    : <MissingOrder/>*/}
        {/*}*/}
        {/*{profile ? <AddressView profile={profile}/> :*/}
        {/*  <AddressView profile={Profile.defaultProps('unknown', 'unknown')}/>}*/}
        {/*{*/}
        {/*  !!lines*/}
        {/*    ?*/}
        {/*    <PaymentReview invoice={invoice.data() as IInvoice}*/}
        {/*                   lines={lines.docs.map((d: firebase.firestore.QueryDocumentSnapshot) => d.data() as IInvoiceLine)}/>*/}
        {/*    : null*/}
        {/*}*/}
      </Grid>

      <Grid item container>
        <CopyToClipboard
          text={`www.scout9.com/actions/${uid}/confirm/${invoice.id}`}
          onCopy={() => setCopiedText(`www.scout9.com/actions/${uid}/confirm/${invoice.id}`)}
        >
          <Tooltip
            title={
              copiedText === `www.scout9.com/actions/${uid}/confirm/${invoice.id}`
                ? 'This was Copied!'
                : 'Copy To Clipboard'
            }
            placement="top"
          >
            <Button variant="contained">Invoice Link</Button>
          </Tooltip>
        </CopyToClipboard>

      </Grid>

    </Grid>
  );
}
